
<template>
    <div class="title">
      <h3 class="name">{{ title }}</h3>
      <a-button type="primary" size="large" class="el_button el-button--primary" @click="GoAdd"> 新增客源 </a-button>
    </div>
</template>

<script>
export default {
    props:{
        title:{
            type:String,
            default:''
        }
    },
    data(){
        return {

        }
    },
    methods:{
        GoAdd(){
            this.$emit('GoAdd')
        }
    }
}
</script>

<style lang="less" scoped>
.title {
    padding: 20px;
    display: flex;
    justify-content: space-between;
    background-color: white;

    .name {
      font-size: 20px;
      font-weight: bold;
      color: #000;
    }

    button {
      background-color: var(--ThemeColor);
      font-size: 14px;
      width: 100px;
      height: 40px;
      border: none;
    }
  }
</style>